import { SelectOption } from 'components/new-ui/composed/formSelect/FormSelect';
import { DeclarationCountry } from '../enums/common/declaration-country';
import { DeclarationInternalType } from '../enums/common/declaration-internal-type';
import {
    aesDeclarationStatuses,
    aisDeclarationStatuses,
    baseDeclarationStatuses,
    cdsDeclarationStatuses,
    gvmsRecordStatuses,
    ics2ArrivalNotificationStatuses,
    ics2DeclarationStatuses,
    nctsDeclarationStatuses,
    DeclarationStatuses,
    getDeclarationStatusLabel,
} from '../enums/common/declaration-status';

export const getDeclarationSelectOptions = (
    country?: DeclarationCountry,
    internalType?: DeclarationInternalType
): SelectOption[] => {
    let statuses;

    if (
        country === DeclarationCountry.IRELAND &&
        (internalType === DeclarationInternalType.EXPORT || internalType === DeclarationInternalType.ARRIVAL)
    )
        statuses = aesDeclarationStatuses;
    else if (country === DeclarationCountry.IRELAND && internalType === DeclarationInternalType.IMPORT) {
        statuses = aisDeclarationStatuses;
    } else if (country === DeclarationCountry.IRELAND && internalType === DeclarationInternalType.NCTS) {
        statuses = nctsDeclarationStatuses;
    } else if (country === DeclarationCountry.UK && internalType === DeclarationInternalType.GVMS) {
        statuses = gvmsRecordStatuses;
    } else if (country === DeclarationCountry.UK) {
        statuses = cdsDeclarationStatuses;
    } else if (
        country === DeclarationCountry.EU &&
        internalType === DeclarationInternalType.ARRIVAL_NOTIFICATION_ICS2
    ) {
        statuses = ics2ArrivalNotificationStatuses;
    } else if (country === DeclarationCountry.EU) {
        statuses = ics2DeclarationStatuses;
    } else statuses = baseDeclarationStatuses;

    return Object.keys(statuses).map((statusKey) => {
        return {
            id: statusKey,
            value: getDeclarationStatusLabel(statusKey as DeclarationStatuses),
        };
    });
};
